import { useEffect, useState } from 'react'
import useAsync from 'react-use/esm/useAsync'
import { SimpleTextarea } from '~/components/common/SimpleTextarea'
import { AgentRequest } from '~/protos/agents'
import { TaskParams } from '../../BaseTaskForm'

interface MulesoftToCamelFormProps {
  onChange: (task: TaskParams) => void
  disabled?: boolean
  initialTaskData?: TaskParams | null
}

export function MulesoftToCamelForm({
  onChange,
  disabled = false,
  initialTaskData
}: MulesoftToCamelFormProps) {
  // Initialize from initialTaskData if editing
  const initialDescription = initialTaskData?.request?.command?.commandString ?? ''
  const [description, setDescription] = useState<string>(initialDescription)

  // Update state when initialTaskData changes (e.g., when editing different tasks)
  useEffect(() => {
    if (initialTaskData?.request?.command?.commandString) {
      setDescription(initialTaskData.request.command.commandString)
    }
  }, [initialTaskData])

  useAsync(async () => {
    if (description != null) {
      const request = AgentRequest.fromPartial({
        command: description ? { commandString: description } : undefined
      })
      onChange?.({ request })
    }
  }, [description])

  return (
    <div className='input-output-form'>
      <div className='flow-name'>
        <div className='label font-semibold text-xs text-default-700 mb-[10px] mt-[10px] select-none'>
          Description:<span className='text-tokens-status-error-text'> *</span>
        </div>
        <SimpleTextarea
          onChange={setDescription}
          minRows={2}
          placeholder='migrate flow post:/employees:muletransform-config to camel'
          defaultValue={initialDescription}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
